/*
***The below commented out JS happens in the bootloader custom JS in VS
const threesixtyview = new threeSixtyView4i();
threesixtyview.Init();
*/

const threeSixtyView4i = function () {	
	const productName = document.getElementById("ProductName").value.replace("\"", " inches").replace("\"", " inches");
	const productNumber = document.querySelector(".prodNumber").textContent;
	
	let init = () => {
		if(Dialog4i){
			const threeSixtyDialog = new Dialog4i();
			const threeSixtyContent = getContent();
			
			threeSixtyDialog.Init({
				triggerElements: document.querySelector('.hyp360View'),
				dialogClass: "three60View largeDialog", 
				title: "360 Degree View",
				content: threeSixtyContent,
				onOpen: open360,
				onClose: close
			});	
		}
	},
	getContent = () => {
		// we have zoom and magnifcation turned off, so I have removed the large image references--> large-filename: 900-{col}.jpg; 
		// variable below would go in the href of the link if turning zoom back on (and uncomment in VS)
		// let zoomImageUrl = document.getElementById("zoomImgURL").value, 
		let contentHTML = 
			'<div class="marginBtm10">' +
				'<h2 class="textSemiBold text18 marginBtm5">' + productName + '</h2>' +
				'<p class="text16">' + productNumber + '</p>' +
			'</div>' +
			'<div id="image360"></div>' + 
			'<div class="marginTop20 displayFlex flexAlignItemsCenter flexSpaceBetween">' +
				'<p id="threeSixtyHint">Spin image left or right</p>' +
				'<div class="gestureBtns displayFlex">' +
					'<button id="spanItemLeft" class="spanLeft bkgdDkGray whiteLink padding10 pointer marginRight10" type="button"><svg class="rotate270 show" height="25px" width="25px" focusable="false" role="img" aria-label="Spin ' + productName + ' Left"><title>Spin ' + productName + ' Left</title><use xlink:href="#svgIcon-arrowLine"></use> </svg></a>' +
					'<button id="spanItemRight" class="spanRight bkgdDkGray whiteLink padding10 pointer" type="button"><svg class="rotate90 show" height="25px" width="25px" focusable="false" role="img" aria-label="Spin ' + productName + ' Right"><title>Spin ' + productName + ' Right</title><use xlink:href="#svgIcon-arrowLine"></use> </svg></a>' +
				'</div>' +
			'</div>' +
			'<span id="threeSixtyLive" class="visually-hidden" role="alert" aria-atomic="true"></span>';
		
		return contentHTML;
	},
	open360 = () => {
		if(document.getElementById("wrapper360")){
			document.getElementById("popUpDialog").querySelector("#image360").append(document.getElementById("wrapper360"));
		}else{
			add360Img();
		}
		get360Class();
		
		document.getElementById("spanItemRight").addEventListener("click", rotateRight);
		document.getElementById("spanItemLeft").addEventListener("click", rotateLeft);		
	},
	add360Img = () => {
		let productImgUrl = document.getElementById("product360Url").value;		
		let spinImage = 
				'<div id="wrapper360" class="hide"><a id="image360Spin" href="#" class="Magic360" data-magic360-options="columns: 36; rows: 1; filename: {col}.jpg; autospin-speed: 1200; fullscreen: false; magnify: false; hint: false;">' + 
					'<img height="600" width="600" class="responsiveImg flyoutImg" src="' + productImgUrl + '" alt="' + productName + ' 360 View" />' +
				'</a></div>';
		
		document.getElementById("popUpDialog").querySelector("#image360").innerHTML = spinImage;
	},
	close = () => {
		//append 360 stuff to body and hide it since I don't know how to re-initialize it once it disappears from DOM
		document.getElementById("wrapper360").classList.add("hide");
		document.querySelector("body").appendChild(document.getElementById("wrapper360")); 
		
	},
	rotateRight = e => {
		e.preventDefault();
		let liveRegion = document.getElementById("threeSixtyLive");
		liveRegion.textContent = "";
		liveRegion.textContent = "360 Image spun to the right";
		
		Magic360.spin('image360Spin', 1);
	},
	rotateLeft = e => {
		e.preventDefault();
		let liveRegion = document.getElementById("threeSixtyLive");
		liveRegion.textContent = "";
		liveRegion.textContent = "360 Image spun to the left";
		
		Magic360.spin('image360Spin', -1);
	},
	get360Class = () => {
		let dialogWrapper = document.querySelector(".largeDialog");
		let flyoutImg = document.querySelector('.flyoutImg');
		
		// image has already been loaded before
		if(document.getElementById("wrapper360").classList.contains("img360_landscape") || document.getElementById("wrapper360").classList.contains("img360_portrait")) {
			let layoutClass = "";
			if(document.getElementById("wrapper360").classList.contains("img360_landscape")) layoutClass = "landscape";
			else if (document.getElementById("wrapper360").classList.contains("img360_portrait")) layoutClass = "portrait";
			dialogWrapper.classList.add(layoutClass);
		// image hasn't been loaded yet
		}else{
			flyoutImg.onload = () => { 
			    	let boxWidth = flyoutImg.naturalWidth;
				let boxHeight = flyoutImg.naturalHeight;
				
				if (boxWidth > boxHeight) {
					dialogWrapper.classList.add('landscape');
					document.getElementById("wrapper360").classList.add("img360_landscape");
				} else {
					dialogWrapper.classList.add('portrait');
					document.getElementById("wrapper360").classList.add("img360_portrait");
				}
				
				//add in the actual height/width of the image to the image tag
				flyoutImg.height = boxHeight;
				flyoutImg.width = boxWidth;
			};
		}
		document.getElementById("wrapper360").classList.remove("hide");
	};

	return {
		Init: init
	};
};